import { useEffect, useState } from "react";
import NavPages from "../../../components/NavPages/navPages";
import Steps from "../../../components/steps";

import styles from "./my-actions.module.css"

import { useLocation } from "react-router-dom";
import MocSteps from "../../../components/search-moc/MocSteps";
import { api } from "../../../services/api";
import BasicInfo from "../../../components/search-moc/basicInfo";
import ChecklistSupport from "../../../components/search-moc/checklistSupport";
import HseApproval from "../../../components/search-moc/hseApproval";
import Actions from "../../../components/search-moc/actions";
import LoadingContent from "../../../components/loadingContent/loadingContent";
import exportToPDF from "../../../utils/exportToPdf";
import Button from "../../../components/Button";
import { printPage } from "../../../utils/pdfExport";
import Swal from "sweetalert2";

export default function ActionsView() {
    const location = useLocation()
    const id = location.state.state
    const codMoc = location.state.codMoc
    const mocTitle = location.state.mocTitle

    console.log(mocTitle)

    // Estado que determina se o moc é completo ou simplificado
    const [isComplete, setIsComplete] = useState(true)
    // Estado que determina se o checklist do moc foi respondido totalmente
    const [isFinished, setIsFinished] = useState(false)

    const [activeDiv, setActiveDiv] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [disableDivsOpacity, setDisableDivsOpacity] = useState(false)

    const [stages, setStages] = useState([])

    const [evidenceObservation, setEvidenceObservation] = useState('')

    useEffect(async () => {
        await getMocStageData()
    }, [])

    async function getMocStageData() {
        try {
            setIsLoading(true)

            let response = await api.get(`/stages/moc/${id}`)

            setStages(response.data)

            if (response.data.length != 3) {
                setIsComplete(false)
            }

        } catch (error) {
            console.error(error)
        } finally {
            setIsLoading(false)
        }
    }

    async function startExporting() {
        setActiveDiv(true)
        setDisableDivsOpacity(true)
        setEvidenceObservation(true)
        await Swal.fire({
            text: 'O carregamento do arquivo pode demorar alguns minutos.',
            icon: 'info',
            confirmButtonColor: "#009EBE",
            confirmButtonText: 'Gerar PDF',
            allowOutsideClick: false,
            didClose: () => {window.print()}
        });
        await new Promise(resolve => setTimeout(resolve, 1000));
        setDisableDivsOpacity(false)
        setEvidenceObservation(false)
    }
    
    return (
        <>
            <Steps
                id={id}
            />

            <NavPages title="Minhas Ações" secondTitle="Ações responsável" />

            <LoadingContent isLoading={isLoading}>
                <div className="exportPdfDiv">
                    <Button onClick={startExporting}>
                        Exportar para PDF</Button>
                </div>


                <div className='mainDiv'>
                    <div className={styles.stepGroup} id="PDFExport">
                        <BasicInfo
                            id={id}
                            activeToggle={activeDiv}
                            disableOpacity={disableDivsOpacity}
                        />

                        <ChecklistSupport
                            id={id}
                            activeToggle={activeDiv}
                            disableOpacity={disableDivsOpacity}
                        />

                        <HseApproval
                            id={id}
                            activeToggle={activeDiv}
                            disableOpacity={disableDivsOpacity}
                        />
                    </div>


                    {!stages.length > 0 ? <div></div> :
                        isComplete ?
                            <div>
                                < div className={styles.stepGroup}>
                                    <MocSteps
                                        id={id}
                                        stageId={1}
                                        readOnly={stages[0].isCompleted}
                                        activeToggle={activeDiv}
                                        disableOpacity={disableDivsOpacity}
                                        evidenceObservation={evidenceObservation}
                                    />
                                </div>

                                {stages[0].isCompleted ?

                                    <div className={styles.stepGroup}>
                                        <MocSteps
                                            id={id}
                                            stageId={2}
                                            readOnly={stages[1]?.isCompleted}
                                            activeToggle={activeDiv}
                                            disableOpacity={disableDivsOpacity}
                                            evidenceObservation={evidenceObservation}
                                        />
                                    </div>

                                    : null}

                                {stages[1]?.isCompleted ?
                                    <div className={styles.stepGroup}>
                                        <MocSteps
                                            id={id}
                                            stageId={3}
                                            readOnly={stages[2]?.isCompleted}
                                            activeToggle={activeDiv}
                                            disableOpacity={disableDivsOpacity}
                                            evidenceObservation={evidenceObservation}
                                        />
                                    </div>
                                    : null}
                            </div>

                            :

                            < div className={styles.stepGroup}>
                                <MocSteps
                                    id={id}
                                    stageId={4}
                                    readOnly={stages[0].isCompleted}
                                    activeToggle={activeDiv}
                                    disableOpacity={disableDivsOpacity}
                                    evidenceObservation={evidenceObservation}
                                />
                            </div>

                    }
                    <div className={styles.stepGroup}>
                        <Actions
                            id={id}
                            codMoc={codMoc}
                            activeToggle={activeDiv}
                        />
                    </div>
                </div>
            </LoadingContent>
        </>
    )
}


